import { createSlice } from '@reduxjs/toolkit'
import { MediaPlaybackState, SetVideoConfigAction } from './types'
import { rootReducer } from '@wellesley/store'

const initialState: MediaPlaybackState = {
  video: {
    volume: 0,
    autoplay: true,
  },
}

export const mediaPlaybackSlice = createSlice({
  name: 'media-playback',
  initialState,
  reducers: {
    setVideoConfig: (state, action: SetVideoConfigAction) => {
      state.video = {
        ...state.video,
        ...action.payload,
      }
    },
  },
  selectors: {
    selectVideoConfig: (state) => state.video,
  },
}).injectInto(rootReducer)
